import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';
import { MISCHKA, ROYAL_BLUE_2, SANTAS_GRAY } from '@/constants/colors';

export const Container = styled.section`
  text-align: center;
  position: relative;

  .services {
    &__content {
      margin-top: 35px;
      /* Removed because there was alot of extra space - why was this added
      min-height: 528px;
      */
    }

    &__tabs {
      margin-bottom: 28px;
      min-height: 50px;
      height: 50px;

      .MuiTabs-indicator {
        display: flex;
        border-radius: 25px;
        background-color: ${ROYAL_BLUE_2};
      }

      .MuiTabs-flexContainer {
        justify-content: flex-start;
        flex-wrap: nowrap;
      }

      .MuiTab-wrapper {
        white-space: nowrap;
        font-size: 1.4rem;
        line-height: 1.4rem;
      }

      .MuiTab-root {
        border-radius: 0;
        padding: 0;
        margin: 0;
        background-color: transparent !important;
        padding: 0 15px;
        display: flex;
        justify-content: center;
        flex: 1;
        border-bottom: 2px solid ${MISCHKA};
        min-width: 180px;
        color: ${SANTAS_GRAY};
        opacity: 1;
      }

      .Mui-selected {
        color: ${ROYAL_BLUE_2};
      }

      ${breakpoints.up('md')} {
        min-height: 50px;
        height: 50px;

        .MuiTab-wrapper {
          font-size: 2rem;
          line-height: 2rem;
          font-weight: 500;
        }

        .Mui-selected {
          .MuiTab-wrapper {
            font-weight: 600;
          }
        }
      }
    }

    &__tabs-content {
      &--unmount {
        min-height: 433px;
      }

      .carousel-services__loading-container {
        margin-top: 45px;
      }
    }

    &__btn {
      margin-top: 30px;
      width: 350px;

      ${breakpoints.down('xs')} {
        width: 100%;
      }
    }
  }
`;

export default Container;
